import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.to-string.js";
import { MessageType } from '../../constants';
/**
 * RequestIframeEndpointHeartbeat
 *
 * Shared "ping -> wait pong" helper.
 * - Works for both server and client endpoints
 * - Uses core.pending for timeout management
 */
export class RequestIframeEndpointHeartbeat {
  constructor(params) {
    this.hub = params.hub;
    this.pendingBucket = params.pendingBucket;
    this.handledBy = params.handledBy;
    this.isOriginAllowed = params.isOriginAllowed;
    this.warnMissingPendingWhenClosed = params.warnMissingPendingWhenClosed;
  }

  /**
   * Send PING and resolve true when PONG arrives, false on timeout.
   */
  ping(peer, timeoutMs, targetId) {
    var requestId = `ping_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    return new Promise(resolve => {
      var timeoutId = this.hub.pending.setTimeout(() => {
        this.hub.pending.delete(this.pendingBucket, requestId);
        resolve(false);
      }, timeoutMs);
      this.hub.pending.set(this.pendingBucket, requestId, {
        resolve,
        timeoutId
      });
      peer.sendMessage(MessageType.PING, requestId, {
        requireAck: true,
        targetId
      });
    });
  }

  /**
   * Handle incoming PONG for ping() waiter.
   */
  handlePong(data, context) {
    if (this.isOriginAllowed && !this.isOriginAllowed(data, context)) return;
    var pending = this.hub.pending.get(this.pendingBucket, data.requestId);
    if (!pending) {
      if (!this.hub.isOpen) {
        var _this$warnMissingPend;
        (_this$warnMissingPend = this.warnMissingPendingWhenClosed) === null || _this$warnMissingPend === void 0 || _this$warnMissingPend.call(this, data);
      }
      return;
    }
    context.markAcceptedBy(this.handledBy);
    this.hub.pending.clearTimeout(pending.timeoutId);
    this.hub.pending.delete(this.pendingBucket, data.requestId);
    pending.resolve(true);
  }
}